import React from 'react';

export default function Loading (props) {
    let className = ['loading-wrapper'];
    props.inline && className.push('loading-inline');
    return (<div className={className.join(' ')}><div className="loading"></div></div>);
}
